import {
  // Dashboard
  FETCH_DASHBOARD,
  FETCH_UPCOMING_MAINTENANCE,
  FETCH_OVERDUE_MAINTENANCE,
  // Machine Types
  FETCH_MACHINE_TYPES,
  FETCH_MACHINE_TYPE,
  CREATE_MACHINE_TYPE,
  UPDATE_MACHINE_TYPE,
  DELETE_MACHINE_TYPE,
  // Facility Types
  FETCH_FACILITY_TYPES,
  FETCH_FACILITY_TYPE,
  CREATE_FACILITY_TYPE,
  UPDATE_FACILITY_TYPE,
  DELETE_FACILITY_TYPE,
  // Locations
  FETCH_MAINTENANCE_LOCATIONS,
  FETCH_MAINTENANCE_LOCATION,
  CREATE_MAINTENANCE_LOCATION,
  UPDATE_MAINTENANCE_LOCATION,
  DELETE_MAINTENANCE_LOCATION,
  // Service Providers
  FETCH_SERVICE_PROVIDERS,
  FETCH_SERVICE_PROVIDER,
  CREATE_SERVICE_PROVIDER,
  UPDATE_SERVICE_PROVIDER,
  DELETE_SERVICE_PROVIDER,
  // Machines
  FETCH_MACHINES,
  FETCH_MACHINE,
  CREATE_MACHINE,
  UPDATE_MACHINE,
  DELETE_MACHINE,
  START_MACHINE_MAINTENANCE,
  FETCH_MACHINE_MAINTENANCE_HISTORY,
  // Facilities
  FETCH_FACILITIES,
  FETCH_FACILITY,
  CREATE_FACILITY,
  UPDATE_FACILITY,
  DELETE_FACILITY,
  FETCH_FACILITY_TASKS,
  // Task Templates
  FETCH_TASK_TEMPLATES,
  FETCH_TASK_TEMPLATE,
  CREATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE,
  // Task Assignments
  FETCH_TASK_ASSIGNMENTS,
  FETCH_TASK_ASSIGNMENT,
  CREATE_TASK_ASSIGNMENT,
  UPDATE_TASK_ASSIGNMENT,
  DELETE_TASK_ASSIGNMENT,
  GENERATE_ASSIGNMENT_TASKS,
  GENERATE_ALL_TASKS,
  // Scheduled Tasks
  FETCH_SCHEDULED_TASKS,
  FETCH_SCHEDULED_TASK,
  FETCH_TASK_DASHBOARD,
  FETCH_TODAY_TASKS,
  FETCH_OVERDUE_TASKS,
  FETCH_UPCOMING_TASKS,
  START_SCHEDULED_TASK,
  COMPLETE_SCHEDULED_TASK,
  SKIP_SCHEDULED_TASK,
  ADD_TASK_PHOTO,
  // Maintenance Records
  FETCH_MAINTENANCE_RECORDS,
  FETCH_MAINTENANCE_RECORD,
  CREATE_MAINTENANCE_RECORD,
  UPDATE_MAINTENANCE_RECORD,
  DELETE_MAINTENANCE_RECORD,
  START_MAINTENANCE_RECORD,
  COMPLETE_MAINTENANCE_RECORD,
  CANCEL_MAINTENANCE_RECORD,
  RECORD_SERVICE_VISIT,
  // Photos
  FETCH_MAINTENANCE_PHOTOS,
  UPLOAD_MAINTENANCE_PHOTO,
  DELETE_MAINTENANCE_PHOTO,
  // Notifications
  FETCH_NOTIFICATIONS,
  FETCH_UNREAD_COUNT,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  // UI State
  CLEAR_MAINTENANCE_ERROR,
  SET_ACTIVE_TAB,
  CLEAR_CURRENT_MACHINE,
  CLEAR_CURRENT_RECORD,
  CLEAR_CURRENT_FACILITY,
  CLEAR_CURRENT_TASK,
  CLEAR_CURRENT_TASK_TEMPLATE,
  CLEAR_CURRENT_TASK_ASSIGNMENT,
} from "./types";
import * as API from "./api";

// ============================================================================
// Dashboard
// ============================================================================
export const fetchDashboard = () => ({
  type: FETCH_DASHBOARD.init,
  payload: API.fetchDashboard(),
});

export const fetchDashboardSuccess = (data) => ({
  type: FETCH_DASHBOARD.success,
  payload: data,
});

export const fetchDashboardFailure = (error) => ({
  type: FETCH_DASHBOARD.failure,
  payload: error,
});

export const fetchUpcomingMaintenance = (days = 30) => ({
  type: FETCH_UPCOMING_MAINTENANCE.init,
  payload: API.fetchUpcomingMaintenance(days),
});

export const fetchUpcomingMaintenanceSuccess = (data) => ({
  type: FETCH_UPCOMING_MAINTENANCE.success,
  payload: data,
});

export const fetchUpcomingMaintenanceFailure = (error) => ({
  type: FETCH_UPCOMING_MAINTENANCE.failure,
  payload: error,
});

export const fetchOverdueMaintenance = () => ({
  type: FETCH_OVERDUE_MAINTENANCE.init,
  payload: API.fetchOverdueMaintenance(),
});

export const fetchOverdueMaintenanceSuccess = (data) => ({
  type: FETCH_OVERDUE_MAINTENANCE.success,
  payload: data,
});

export const fetchOverdueMaintenanceFailure = (error) => ({
  type: FETCH_OVERDUE_MAINTENANCE.failure,
  payload: error,
});

// ============================================================================
// Machine Types
// ============================================================================
export const fetchMachineTypes = (page = 1, isActive = null, search = null, pageSize = null) => ({
  type: FETCH_MACHINE_TYPES.init,
  payload: API.fetchMachineTypes(page, isActive, search, pageSize),
});

export const fetchMachineTypesSuccess = (data) => ({
  type: FETCH_MACHINE_TYPES.success,
  payload: data,
});

export const fetchMachineTypesFailure = (error) => ({
  type: FETCH_MACHINE_TYPES.failure,
  payload: error,
});

export const fetchMachineType = (id) => ({
  type: FETCH_MACHINE_TYPE.init,
  payload: API.fetchMachineType(id),
});

export const fetchMachineTypeSuccess = (data) => ({
  type: FETCH_MACHINE_TYPE.success,
  payload: data,
});

export const fetchMachineTypeFailure = (error) => ({
  type: FETCH_MACHINE_TYPE.failure,
  payload: error,
});

export const createMachineType = (data) => ({
  type: CREATE_MACHINE_TYPE.init,
  payload: API.createMachineType(data),
});

export const createMachineTypeSuccess = (data) => ({
  type: CREATE_MACHINE_TYPE.success,
  payload: data,
});

export const createMachineTypeFailure = (error) => ({
  type: CREATE_MACHINE_TYPE.failure,
  payload: error,
});

export const updateMachineType = (id, data) => ({
  type: UPDATE_MACHINE_TYPE.init,
  payload: API.updateMachineType(id, data),
});

export const updateMachineTypeSuccess = (data) => ({
  type: UPDATE_MACHINE_TYPE.success,
  payload: data,
});

export const updateMachineTypeFailure = (error) => ({
  type: UPDATE_MACHINE_TYPE.failure,
  payload: error,
});

export const deleteMachineType = (id) => ({
  type: DELETE_MACHINE_TYPE.init,
  payload: API.deleteMachineType(id),
});

export const deleteMachineTypeSuccess = (id) => ({
  type: DELETE_MACHINE_TYPE.success,
  payload: id,
});

export const deleteMachineTypeFailure = (error) => ({
  type: DELETE_MACHINE_TYPE.failure,
  payload: error,
});

// ============================================================================
// Facility Types
// ============================================================================
export const fetchFacilityTypes = (page = 1, isActive = null, search = null, pageSize = null) => ({
  type: FETCH_FACILITY_TYPES.init,
  payload: API.fetchFacilityTypes(page, isActive, search, pageSize),
});

export const fetchFacilityTypesSuccess = (data) => ({
  type: FETCH_FACILITY_TYPES.success,
  payload: data,
});

export const fetchFacilityTypesFailure = (error) => ({
  type: FETCH_FACILITY_TYPES.failure,
  payload: error,
});

export const fetchFacilityType = (id) => ({
  type: FETCH_FACILITY_TYPE.init,
  payload: API.fetchFacilityType(id),
});

export const fetchFacilityTypeSuccess = (data) => ({
  type: FETCH_FACILITY_TYPE.success,
  payload: data,
});

export const fetchFacilityTypeFailure = (error) => ({
  type: FETCH_FACILITY_TYPE.failure,
  payload: error,
});

export const createFacilityType = (data) => ({
  type: CREATE_FACILITY_TYPE.init,
  payload: API.createFacilityType(data),
});

export const createFacilityTypeSuccess = (data) => ({
  type: CREATE_FACILITY_TYPE.success,
  payload: data,
});

export const createFacilityTypeFailure = (error) => ({
  type: CREATE_FACILITY_TYPE.failure,
  payload: error,
});

export const updateFacilityType = (id, data) => ({
  type: UPDATE_FACILITY_TYPE.init,
  payload: API.updateFacilityType(id, data),
});

export const updateFacilityTypeSuccess = (data) => ({
  type: UPDATE_FACILITY_TYPE.success,
  payload: data,
});

export const updateFacilityTypeFailure = (error) => ({
  type: UPDATE_FACILITY_TYPE.failure,
  payload: error,
});

export const deleteFacilityType = (id) => ({
  type: DELETE_FACILITY_TYPE.init,
  payload: API.deleteFacilityType(id),
});

export const deleteFacilityTypeSuccess = (id) => ({
  type: DELETE_FACILITY_TYPE.success,
  payload: id,
});

export const deleteFacilityTypeFailure = (error) => ({
  type: DELETE_FACILITY_TYPE.failure,
  payload: error,
});

// ============================================================================
// Locations
// ============================================================================
export const fetchMaintenanceLocations = (page = 1, isActive = null, search = null, pageSize = null) => ({
  type: FETCH_MAINTENANCE_LOCATIONS.init,
  payload: API.fetchLocations(page, isActive, search, pageSize),
});

export const fetchMaintenanceLocationsSuccess = (data) => ({
  type: FETCH_MAINTENANCE_LOCATIONS.success,
  payload: data,
});

export const fetchMaintenanceLocationsFailure = (error) => ({
  type: FETCH_MAINTENANCE_LOCATIONS.failure,
  payload: error,
});

export const fetchMaintenanceLocation = (id) => ({
  type: FETCH_MAINTENANCE_LOCATION.init,
  payload: API.fetchLocation(id),
});

export const fetchMaintenanceLocationSuccess = (data) => ({
  type: FETCH_MAINTENANCE_LOCATION.success,
  payload: data,
});

export const fetchMaintenanceLocationFailure = (error) => ({
  type: FETCH_MAINTENANCE_LOCATION.failure,
  payload: error,
});

export const createMaintenanceLocation = (data) => ({
  type: CREATE_MAINTENANCE_LOCATION.init,
  payload: API.createLocation(data),
});

export const createMaintenanceLocationSuccess = (data) => ({
  type: CREATE_MAINTENANCE_LOCATION.success,
  payload: data,
});

export const createMaintenanceLocationFailure = (error) => ({
  type: CREATE_MAINTENANCE_LOCATION.failure,
  payload: error,
});

export const updateMaintenanceLocation = (id, data) => ({
  type: UPDATE_MAINTENANCE_LOCATION.init,
  payload: API.updateLocation(id, data),
});

export const updateMaintenanceLocationSuccess = (data) => ({
  type: UPDATE_MAINTENANCE_LOCATION.success,
  payload: data,
});

export const updateMaintenanceLocationFailure = (error) => ({
  type: UPDATE_MAINTENANCE_LOCATION.failure,
  payload: error,
});

export const deleteMaintenanceLocation = (id) => ({
  type: DELETE_MAINTENANCE_LOCATION.init,
  payload: API.deleteLocation(id),
});

export const deleteMaintenanceLocationSuccess = (id) => ({
  type: DELETE_MAINTENANCE_LOCATION.success,
  payload: id,
});

export const deleteMaintenanceLocationFailure = (error) => ({
  type: DELETE_MAINTENANCE_LOCATION.failure,
  payload: error,
});

// ============================================================================
// Service Providers
// ============================================================================
export const fetchServiceProviders = (page = 1, isActive = null, search = null, pageSize = null) => ({
  type: FETCH_SERVICE_PROVIDERS.init,
  payload: API.fetchServiceProviders(page, isActive, search, pageSize),
});

export const fetchServiceProvidersSuccess = (data) => ({
  type: FETCH_SERVICE_PROVIDERS.success,
  payload: data,
});

export const fetchServiceProvidersFailure = (error) => ({
  type: FETCH_SERVICE_PROVIDERS.failure,
  payload: error,
});

export const fetchServiceProvider = (id) => ({
  type: FETCH_SERVICE_PROVIDER.init,
  payload: API.fetchServiceProvider(id),
});

export const fetchServiceProviderSuccess = (data) => ({
  type: FETCH_SERVICE_PROVIDER.success,
  payload: data,
});

export const fetchServiceProviderFailure = (error) => ({
  type: FETCH_SERVICE_PROVIDER.failure,
  payload: error,
});

export const createServiceProvider = (data) => ({
  type: CREATE_SERVICE_PROVIDER.init,
  payload: API.createServiceProvider(data),
});

export const createServiceProviderSuccess = (data) => ({
  type: CREATE_SERVICE_PROVIDER.success,
  payload: data,
});

export const createServiceProviderFailure = (error) => ({
  type: CREATE_SERVICE_PROVIDER.failure,
  payload: error,
});

export const updateServiceProvider = (id, data) => ({
  type: UPDATE_SERVICE_PROVIDER.init,
  payload: API.updateServiceProvider(id, data),
});

export const updateServiceProviderSuccess = (data) => ({
  type: UPDATE_SERVICE_PROVIDER.success,
  payload: data,
});

export const updateServiceProviderFailure = (error) => ({
  type: UPDATE_SERVICE_PROVIDER.failure,
  payload: error,
});

export const deleteServiceProvider = (id) => ({
  type: DELETE_SERVICE_PROVIDER.init,
  payload: API.deleteServiceProvider(id),
});

export const deleteServiceProviderSuccess = (id) => ({
  type: DELETE_SERVICE_PROVIDER.success,
  payload: id,
});

export const deleteServiceProviderFailure = (error) => ({
  type: DELETE_SERVICE_PROVIDER.failure,
  payload: error,
});

// ============================================================================
// Machines
// ============================================================================
export const fetchMachines = (page = 1, machineType = null, location = null, status = null, search = null, pageSize = null) => ({
  type: FETCH_MACHINES.init,
  payload: API.fetchMachines(page, machineType, location, status, search, pageSize),
});

export const fetchMachinesSuccess = (data) => ({
  type: FETCH_MACHINES.success,
  payload: data,
});

export const fetchMachinesFailure = (error) => ({
  type: FETCH_MACHINES.failure,
  payload: error,
});

export const fetchMachine = (id) => ({
  type: FETCH_MACHINE.init,
  payload: API.fetchMachine(id),
});

export const fetchMachineSuccess = (data) => ({
  type: FETCH_MACHINE.success,
  payload: data,
});

export const fetchMachineFailure = (error) => ({
  type: FETCH_MACHINE.failure,
  payload: error,
});

export const createMachine = (data) => ({
  type: CREATE_MACHINE.init,
  payload: API.createMachine(data),
});

export const createMachineSuccess = (data) => ({
  type: CREATE_MACHINE.success,
  payload: data,
});

export const createMachineFailure = (error) => ({
  type: CREATE_MACHINE.failure,
  payload: error,
});

export const updateMachine = (id, data) => ({
  type: UPDATE_MACHINE.init,
  payload: API.updateMachine(id, data),
});

export const updateMachineSuccess = (data) => ({
  type: UPDATE_MACHINE.success,
  payload: data,
});

export const updateMachineFailure = (error) => ({
  type: UPDATE_MACHINE.failure,
  payload: error,
});

export const deleteMachine = (id) => ({
  type: DELETE_MACHINE.init,
  payload: API.deleteMachine(id),
});

export const deleteMachineSuccess = (id) => ({
  type: DELETE_MACHINE.success,
  payload: id,
});

export const deleteMachineFailure = (error) => ({
  type: DELETE_MACHINE.failure,
  payload: error,
});

export const startMachineMaintenance = (id) => ({
  type: START_MACHINE_MAINTENANCE.init,
  payload: API.startMachineMaintenance(id),
});

export const startMachineMaintenanceSuccess = (data) => ({
  type: START_MACHINE_MAINTENANCE.success,
  payload: data,
});

export const startMachineMaintenanceFailure = (error) => ({
  type: START_MACHINE_MAINTENANCE.failure,
  payload: error,
});

export const fetchMachineMaintenanceHistory = (id) => ({
  type: FETCH_MACHINE_MAINTENANCE_HISTORY.init,
  payload: API.fetchMachineMaintenanceHistory(id),
});

export const fetchMachineMaintenanceHistorySuccess = (data) => ({
  type: FETCH_MACHINE_MAINTENANCE_HISTORY.success,
  payload: data,
});

export const fetchMachineMaintenanceHistoryFailure = (error) => ({
  type: FETCH_MACHINE_MAINTENANCE_HISTORY.failure,
  payload: error,
});

// ============================================================================
// Facilities
// ============================================================================
export const fetchFacilities = (page = 1, facilityType = null, location = null, status = null, search = null, pageSize = null) => ({
  type: FETCH_FACILITIES.init,
  payload: API.fetchFacilities(page, facilityType, location, status, search, pageSize),
});

export const fetchFacilitiesSuccess = (data) => ({
  type: FETCH_FACILITIES.success,
  payload: data,
});

export const fetchFacilitiesFailure = (error) => ({
  type: FETCH_FACILITIES.failure,
  payload: error,
});

export const fetchFacility = (id) => ({
  type: FETCH_FACILITY.init,
  payload: API.fetchFacility(id),
});

export const fetchFacilitySuccess = (data) => ({
  type: FETCH_FACILITY.success,
  payload: data,
});

export const fetchFacilityFailure = (error) => ({
  type: FETCH_FACILITY.failure,
  payload: error,
});

export const createFacility = (data) => ({
  type: CREATE_FACILITY.init,
  payload: API.createFacility(data),
});

export const createFacilitySuccess = (data) => ({
  type: CREATE_FACILITY.success,
  payload: data,
});

export const createFacilityFailure = (error) => ({
  type: CREATE_FACILITY.failure,
  payload: error,
});

export const updateFacility = (id, data) => ({
  type: UPDATE_FACILITY.init,
  payload: API.updateFacility(id, data),
});

export const updateFacilitySuccess = (data) => ({
  type: UPDATE_FACILITY.success,
  payload: data,
});

export const updateFacilityFailure = (error) => ({
  type: UPDATE_FACILITY.failure,
  payload: error,
});

export const deleteFacility = (id) => ({
  type: DELETE_FACILITY.init,
  payload: API.deleteFacility(id),
});

export const deleteFacilitySuccess = (id) => ({
  type: DELETE_FACILITY.success,
  payload: id,
});

export const deleteFacilityFailure = (error) => ({
  type: DELETE_FACILITY.failure,
  payload: error,
});

export const fetchFacilityTasks = (id, status = null) => ({
  type: FETCH_FACILITY_TASKS.init,
  payload: API.fetchFacilityTasks(id, status),
});

export const fetchFacilityTasksSuccess = (data) => ({
  type: FETCH_FACILITY_TASKS.success,
  payload: data,
});

export const fetchFacilityTasksFailure = (error) => ({
  type: FETCH_FACILITY_TASKS.failure,
  payload: error,
});

// ============================================================================
// Task Templates
// ============================================================================
export const fetchTaskTemplates = (page = 1, taskType = null, targetType = null, frequency = null, isActive = null, search = null, pageSize = null) => ({
  type: FETCH_TASK_TEMPLATES.init,
  payload: API.fetchTaskTemplates(page, taskType, targetType, frequency, isActive, search, pageSize),
});

export const fetchTaskTemplatesSuccess = (data) => ({
  type: FETCH_TASK_TEMPLATES.success,
  payload: data,
});

export const fetchTaskTemplatesFailure = (error) => ({
  type: FETCH_TASK_TEMPLATES.failure,
  payload: error,
});

export const fetchTaskTemplate = (id) => ({
  type: FETCH_TASK_TEMPLATE.init,
  payload: API.fetchTaskTemplate(id),
});

export const fetchTaskTemplateSuccess = (data) => ({
  type: FETCH_TASK_TEMPLATE.success,
  payload: data,
});

export const fetchTaskTemplateFailure = (error) => ({
  type: FETCH_TASK_TEMPLATE.failure,
  payload: error,
});

export const createTaskTemplate = (data) => ({
  type: CREATE_TASK_TEMPLATE.init,
  payload: API.createTaskTemplate(data),
});

export const createTaskTemplateSuccess = (data) => ({
  type: CREATE_TASK_TEMPLATE.success,
  payload: data,
});

export const createTaskTemplateFailure = (error) => ({
  type: CREATE_TASK_TEMPLATE.failure,
  payload: error,
});

export const updateTaskTemplate = (id, data) => ({
  type: UPDATE_TASK_TEMPLATE.init,
  payload: API.updateTaskTemplate(id, data),
});

export const updateTaskTemplateSuccess = (data) => ({
  type: UPDATE_TASK_TEMPLATE.success,
  payload: data,
});

export const updateTaskTemplateFailure = (error) => ({
  type: UPDATE_TASK_TEMPLATE.failure,
  payload: error,
});

export const deleteTaskTemplate = (id) => ({
  type: DELETE_TASK_TEMPLATE.init,
  payload: API.deleteTaskTemplate(id),
});

export const deleteTaskTemplateSuccess = (id) => ({
  type: DELETE_TASK_TEMPLATE.success,
  payload: id,
});

export const deleteTaskTemplateFailure = (error) => ({
  type: DELETE_TASK_TEMPLATE.failure,
  payload: error,
});

// ============================================================================
// Task Assignments
// ============================================================================
export const fetchTaskAssignments = (page = 1, templateId = null, machineId = null, facilityId = null, isActive = null) => ({
  type: FETCH_TASK_ASSIGNMENTS.init,
  payload: API.fetchTaskAssignments(page, templateId, machineId, facilityId, isActive),
});

export const fetchTaskAssignmentsSuccess = (data) => ({
  type: FETCH_TASK_ASSIGNMENTS.success,
  payload: data,
});

export const fetchTaskAssignmentsFailure = (error) => ({
  type: FETCH_TASK_ASSIGNMENTS.failure,
  payload: error,
});

export const fetchTaskAssignment = (id) => ({
  type: FETCH_TASK_ASSIGNMENT.init,
  payload: API.fetchTaskAssignment(id),
});

export const fetchTaskAssignmentSuccess = (data) => ({
  type: FETCH_TASK_ASSIGNMENT.success,
  payload: data,
});

export const fetchTaskAssignmentFailure = (error) => ({
  type: FETCH_TASK_ASSIGNMENT.failure,
  payload: error,
});

export const createTaskAssignment = (data) => ({
  type: CREATE_TASK_ASSIGNMENT.init,
  payload: API.createTaskAssignment(data),
});

export const createTaskAssignmentSuccess = (data) => ({
  type: CREATE_TASK_ASSIGNMENT.success,
  payload: data,
});

export const createTaskAssignmentFailure = (error) => ({
  type: CREATE_TASK_ASSIGNMENT.failure,
  payload: error,
});

export const updateTaskAssignment = (id, data) => ({
  type: UPDATE_TASK_ASSIGNMENT.init,
  payload: API.updateTaskAssignment(id, data),
});

export const updateTaskAssignmentSuccess = (data) => ({
  type: UPDATE_TASK_ASSIGNMENT.success,
  payload: data,
});

export const updateTaskAssignmentFailure = (error) => ({
  type: UPDATE_TASK_ASSIGNMENT.failure,
  payload: error,
});

export const deleteTaskAssignment = (id) => ({
  type: DELETE_TASK_ASSIGNMENT.init,
  payload: API.deleteTaskAssignment(id),
});

export const deleteTaskAssignmentSuccess = (id) => ({
  type: DELETE_TASK_ASSIGNMENT.success,
  payload: id,
});

export const deleteTaskAssignmentFailure = (error) => ({
  type: DELETE_TASK_ASSIGNMENT.failure,
  payload: error,
});

export const generateAssignmentTasks = (id, daysAhead = 30) => ({
  type: GENERATE_ASSIGNMENT_TASKS.init,
  payload: API.generateAssignmentTasks(id, daysAhead),
});

export const generateAssignmentTasksSuccess = (data) => ({
  type: GENERATE_ASSIGNMENT_TASKS.success,
  payload: data,
});

export const generateAssignmentTasksFailure = (error) => ({
  type: GENERATE_ASSIGNMENT_TASKS.failure,
  payload: error,
});

export const generateAllTasks = (daysAhead = 30) => ({
  type: GENERATE_ALL_TASKS.init,
  payload: API.generateAllTasks(daysAhead),
});

export const generateAllTasksSuccess = (data) => ({
  type: GENERATE_ALL_TASKS.success,
  payload: data,
});

export const generateAllTasksFailure = (error) => ({
  type: GENERATE_ALL_TASKS.failure,
  payload: error,
});

// ============================================================================
// Scheduled Tasks
// ============================================================================
export const fetchScheduledTasks = (status = null, taskType = null, targetType = null) => ({
  type: FETCH_SCHEDULED_TASKS.init,
  payload: API.fetchScheduledTasks(status, taskType, targetType),
});

export const fetchScheduledTasksSuccess = (data) => ({
  type: FETCH_SCHEDULED_TASKS.success,
  payload: data,
});

export const fetchScheduledTasksFailure = (error) => ({
  type: FETCH_SCHEDULED_TASKS.failure,
  payload: error,
});

export const fetchScheduledTask = (id) => ({
  type: FETCH_SCHEDULED_TASK.init,
  payload: API.fetchScheduledTask(id),
});

export const fetchScheduledTaskSuccess = (data) => ({
  type: FETCH_SCHEDULED_TASK.success,
  payload: data,
});

export const fetchScheduledTaskFailure = (error) => ({
  type: FETCH_SCHEDULED_TASK.failure,
  payload: error,
});

export const fetchTaskDashboard = () => ({
  type: FETCH_TASK_DASHBOARD.init,
  payload: API.fetchTaskDashboard(),
});

export const fetchTaskDashboardSuccess = (data) => ({
  type: FETCH_TASK_DASHBOARD.success,
  payload: data,
});

export const fetchTaskDashboardFailure = (error) => ({
  type: FETCH_TASK_DASHBOARD.failure,
  payload: error,
});

export const fetchTodayTasks = () => ({
  type: FETCH_TODAY_TASKS.init,
  payload: API.fetchTodayTasks(),
});

export const fetchTodayTasksSuccess = (data) => ({
  type: FETCH_TODAY_TASKS.success,
  payload: data,
});

export const fetchTodayTasksFailure = (error) => ({
  type: FETCH_TODAY_TASKS.failure,
  payload: error,
});

export const fetchOverdueTasks = () => ({
  type: FETCH_OVERDUE_TASKS.init,
  payload: API.fetchOverdueTasks(),
});

export const fetchOverdueTasksSuccess = (data) => ({
  type: FETCH_OVERDUE_TASKS.success,
  payload: data,
});

export const fetchOverdueTasksFailure = (error) => ({
  type: FETCH_OVERDUE_TASKS.failure,
  payload: error,
});

export const fetchUpcomingTasks = (days = 7) => ({
  type: FETCH_UPCOMING_TASKS.init,
  payload: API.fetchUpcomingTasks(days),
});

export const fetchUpcomingTasksSuccess = (data) => ({
  type: FETCH_UPCOMING_TASKS.success,
  payload: data,
});

export const fetchUpcomingTasksFailure = (error) => ({
  type: FETCH_UPCOMING_TASKS.failure,
  payload: error,
});

export const startScheduledTask = (id) => ({
  type: START_SCHEDULED_TASK.init,
  payload: API.startScheduledTask(id),
});

export const startScheduledTaskSuccess = (data) => ({
  type: START_SCHEDULED_TASK.success,
  payload: data,
});

export const startScheduledTaskFailure = (error) => ({
  type: START_SCHEDULED_TASK.failure,
  payload: error,
});

export const completeScheduledTask = (id, data) => ({
  type: COMPLETE_SCHEDULED_TASK.init,
  payload: API.completeScheduledTask(id, data),
});

export const completeScheduledTaskSuccess = (data) => ({
  type: COMPLETE_SCHEDULED_TASK.success,
  payload: data,
});

export const completeScheduledTaskFailure = (error) => ({
  type: COMPLETE_SCHEDULED_TASK.failure,
  payload: error,
});

export const skipScheduledTask = (id, data) => ({
  type: SKIP_SCHEDULED_TASK.init,
  payload: API.skipScheduledTask(id, data),
});

export const skipScheduledTaskSuccess = (data) => ({
  type: SKIP_SCHEDULED_TASK.success,
  payload: data,
});

export const skipScheduledTaskFailure = (error) => ({
  type: SKIP_SCHEDULED_TASK.failure,
  payload: error,
});

export const addTaskPhoto = (id, photoData) => ({
  type: ADD_TASK_PHOTO.init,
  payload: API.addTaskPhoto(id, photoData),
});

export const addTaskPhotoSuccess = (data) => ({
  type: ADD_TASK_PHOTO.success,
  payload: data,
});

export const addTaskPhotoFailure = (error) => ({
  type: ADD_TASK_PHOTO.failure,
  payload: error,
});

// ============================================================================
// Maintenance Records
// ============================================================================
export const fetchMaintenanceRecords = (page = 1, machine = null, status = null, maintenanceType = null, serviceProvider = null, search = null) => ({
  type: FETCH_MAINTENANCE_RECORDS.init,
  payload: API.fetchMaintenanceRecords(page, machine, status, maintenanceType, serviceProvider, search),
});

export const fetchMaintenanceRecordsSuccess = (data) => ({
  type: FETCH_MAINTENANCE_RECORDS.success,
  payload: data,
});

export const fetchMaintenanceRecordsFailure = (error) => ({
  type: FETCH_MAINTENANCE_RECORDS.failure,
  payload: error,
});

export const fetchMaintenanceRecord = (id) => ({
  type: FETCH_MAINTENANCE_RECORD.init,
  payload: API.fetchMaintenanceRecord(id),
});

export const fetchMaintenanceRecordSuccess = (data) => ({
  type: FETCH_MAINTENANCE_RECORD.success,
  payload: data,
});

export const fetchMaintenanceRecordFailure = (error) => ({
  type: FETCH_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const createMaintenanceRecord = (data) => ({
  type: CREATE_MAINTENANCE_RECORD.init,
  payload: API.createMaintenanceRecord(data),
});

export const createMaintenanceRecordSuccess = (data) => ({
  type: CREATE_MAINTENANCE_RECORD.success,
  payload: data,
});

export const createMaintenanceRecordFailure = (error) => ({
  type: CREATE_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const updateMaintenanceRecord = (id, data) => ({
  type: UPDATE_MAINTENANCE_RECORD.init,
  payload: API.updateMaintenanceRecord(id, data),
});

export const updateMaintenanceRecordSuccess = (data) => ({
  type: UPDATE_MAINTENANCE_RECORD.success,
  payload: data,
});

export const updateMaintenanceRecordFailure = (error) => ({
  type: UPDATE_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const deleteMaintenanceRecord = (id) => ({
  type: DELETE_MAINTENANCE_RECORD.init,
  payload: API.deleteMaintenanceRecord(id),
});

export const deleteMaintenanceRecordSuccess = (id) => ({
  type: DELETE_MAINTENANCE_RECORD.success,
  payload: id,
});

export const deleteMaintenanceRecordFailure = (error) => ({
  type: DELETE_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const startMaintenanceRecord = (id) => ({
  type: START_MAINTENANCE_RECORD.init,
  payload: API.startMaintenanceRecord(id),
});

export const startMaintenanceRecordSuccess = (data) => ({
  type: START_MAINTENANCE_RECORD.success,
  payload: data,
});

export const startMaintenanceRecordFailure = (error) => ({
  type: START_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const completeMaintenanceRecord = (id, data) => ({
  type: COMPLETE_MAINTENANCE_RECORD.init,
  payload: API.completeMaintenanceRecord(id, data),
});

export const completeMaintenanceRecordSuccess = (data) => ({
  type: COMPLETE_MAINTENANCE_RECORD.success,
  payload: data,
});

export const completeMaintenanceRecordFailure = (error) => ({
  type: COMPLETE_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const cancelMaintenanceRecord = (id) => ({
  type: CANCEL_MAINTENANCE_RECORD.init,
  payload: API.cancelMaintenanceRecord(id),
});

export const cancelMaintenanceRecordSuccess = (data) => ({
  type: CANCEL_MAINTENANCE_RECORD.success,
  payload: data,
});

export const cancelMaintenanceRecordFailure = (error) => ({
  type: CANCEL_MAINTENANCE_RECORD.failure,
  payload: error,
});

export const recordServiceVisit = (data) => ({
  type: RECORD_SERVICE_VISIT.init,
  payload: API.recordServiceVisit(data),
});

export const recordServiceVisitSuccess = (data) => ({
  type: RECORD_SERVICE_VISIT.success,
  payload: data,
});

export const recordServiceVisitFailure = (error) => ({
  type: RECORD_SERVICE_VISIT.failure,
  payload: error,
});

// ============================================================================
// Maintenance Photos
// ============================================================================
export const fetchMaintenancePhotos = (page = 1, maintenanceRecord = null, photoType = null) => ({
  type: FETCH_MAINTENANCE_PHOTOS.init,
  payload: API.fetchMaintenancePhotos(page, maintenanceRecord, photoType),
});

export const fetchMaintenancePhotosSuccess = (data) => ({
  type: FETCH_MAINTENANCE_PHOTOS.success,
  payload: data,
});

export const fetchMaintenancePhotosFailure = (error) => ({
  type: FETCH_MAINTENANCE_PHOTOS.failure,
  payload: error,
});

export const uploadMaintenancePhoto = (data) => ({
  type: UPLOAD_MAINTENANCE_PHOTO.init,
  payload: API.uploadMaintenancePhoto(data),
});

export const uploadMaintenancePhotoSuccess = (data) => ({
  type: UPLOAD_MAINTENANCE_PHOTO.success,
  payload: data,
});

export const uploadMaintenancePhotoFailure = (error) => ({
  type: UPLOAD_MAINTENANCE_PHOTO.failure,
  payload: error,
});

export const deleteMaintenancePhoto = (id) => ({
  type: DELETE_MAINTENANCE_PHOTO.init,
  payload: API.deleteMaintenancePhoto(id),
});

export const deleteMaintenancePhotoSuccess = (id) => ({
  type: DELETE_MAINTENANCE_PHOTO.success,
  payload: id,
});

export const deleteMaintenancePhotoFailure = (error) => ({
  type: DELETE_MAINTENANCE_PHOTO.failure,
  payload: error,
});

// ============================================================================
// Notifications
// ============================================================================
export const fetchNotifications = (page = 1, machine = null, notificationType = null, isRead = null) => ({
  type: FETCH_NOTIFICATIONS.init,
  payload: API.fetchNotifications(page, machine, notificationType, isRead),
});

export const fetchNotificationsSuccess = (data) => ({
  type: FETCH_NOTIFICATIONS.success,
  payload: data,
});

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS.failure,
  payload: error,
});

export const fetchUnreadCount = () => ({
  type: FETCH_UNREAD_COUNT.init,
  payload: API.fetchUnreadCount(),
});

export const fetchUnreadCountSuccess = (data) => ({
  type: FETCH_UNREAD_COUNT.success,
  payload: data,
});

export const fetchUnreadCountFailure = (error) => ({
  type: FETCH_UNREAD_COUNT.failure,
  payload: error,
});

export const markNotificationRead = (id) => ({
  type: MARK_NOTIFICATION_READ.init,
  payload: API.markNotificationRead(id),
});

export const markNotificationReadSuccess = (data, id) => ({
  type: MARK_NOTIFICATION_READ.success,
  payload: { ...data, id },
});

export const markNotificationReadFailure = (error) => ({
  type: MARK_NOTIFICATION_READ.failure,
  payload: error,
});

export const markAllNotificationsRead = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ.init,
  payload: API.markAllNotificationsRead(),
});

export const markAllNotificationsReadSuccess = (data) => ({
  type: MARK_ALL_NOTIFICATIONS_READ.success,
  payload: data,
});

export const markAllNotificationsReadFailure = (error) => ({
  type: MARK_ALL_NOTIFICATIONS_READ.failure,
  payload: error,
});

// ============================================================================
// UI State Actions
// ============================================================================
export const clearMaintenanceError = () => ({
  type: CLEAR_MAINTENANCE_ERROR,
});

export const setActiveTab = (tab) => ({
  type: SET_ACTIVE_TAB,
  payload: tab,
});

export const clearCurrentMachine = () => ({
  type: CLEAR_CURRENT_MACHINE,
});

export const clearCurrentRecord = () => ({
  type: CLEAR_CURRENT_RECORD,
});

export const clearCurrentFacility = () => ({
  type: CLEAR_CURRENT_FACILITY,
});

export const clearCurrentTask = () => ({
  type: CLEAR_CURRENT_TASK,
});

export const clearCurrentTaskTemplate = () => ({
  type: CLEAR_CURRENT_TASK_TEMPLATE,
});

export const clearCurrentTaskAssignment = () => ({
  type: CLEAR_CURRENT_TASK_ASSIGNMENT,
});
